// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7776) return "static/chunks/477d4af2-e3f60465898317c2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7714":"2c3184953f45b0be","8699":"890613b27191ec76"}[chunkId] + ".js";
};